// Login screen — Linear'ın e-posta giriş ekranı dili (spec 2026-08-03).
//
// 🔴 Ekran BUTONLA BİTER. Kaldırılanlar ve sebepleri (hepsi 2026-08-03'te ölçüldü):
//   · "Beni hatırla"      → state vardı ama login()'e hiç geçmiyordu
//   · "Şifremi unuttum"   → href="#" + preventDefault(), ölü link
//   · "Demo talep edin"   → aynı desen, ölü link
//   · "Sistem Çevrimiçi"  → sabit metin, hiçbir sağlık kontrolüne bağlı değil
//   · "v2.4.1"            → elle yazılmış sürüm, build'den gelmiyor
//   · güven şeridi        → "ISO 27001" iddiası doğrulanmamıştı
// Kapılar Login.test.tsx'te; geri koyarsanız test kırılır.
import { useState, type FormEvent } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '../contexts/AuthContext';
import { I } from '../components/yeni-design/icons';
import { Wordmark } from '../components/yeni-design/Wordmark';

export function LoginPage() {
  const { login, isDemo } = useAuth();
  const navigate = useNavigate();

  const [showPwd, setShowPwd] = useState(false);
  const [email, setEmail] = useState('');
  const [pwd, setPwd] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setError(null);
    setSubmitting(true);
    try {
      if (isDemo) {
        await login();
      } else {
        await login(email.trim(), pwd);
      }
      navigate('/', { replace: true });
    } catch (err) {
      let msg = 'Giriş başarısız. E-posta ve şifrenizi kontrol edin.';
      if (axios.isAxiosError(err)) {
        const status = err.response?.status;
        if (status === 401 || status === 403) {
          msg = 'E-posta veya şifre hatalı.';
        } else if (status === 429) {
          msg = 'Çok fazla deneme. Lütfen birkaç dakika sonra tekrar deneyin.';
        } else if (status && status >= 500) {
          msg = 'Sunucuya ulaşılamıyor. Lütfen tekrar deneyin.';
        } else if (err.response?.data && typeof err.response.data === 'object') {
          const body = err.response.data as { message?: string; error?: string };
          if (body.message) msg = body.message;
          else if (body.error) msg = body.error;
        }
      } else if (err instanceof Error && err.message) {
        msg = err.message;
      }
      setError(msg);
    } finally {
      setSubmitting(false);
    }
  };

  // Ölçüler Yerlice'nin login.css'iyle BİREBİR aynı; burada Tailwind arbitrary
  // değerleriyle taşınıyor. Ayrışmayı loginOlculeri.test.ts yakalar.
  // 🔴 #6b6b6e (Yerlice görevinden devralınan karar): #8e8e91 beyaz üstünde
  // 3,27 kontrast verir, bu repoda WCAG AA (4,5) kapısı var. #6b6b6e → 5,31.
  // 🔴 focus:outline-none tarayıcının yerel odak halkasını kaldırıyor; yerine Yerlice
  // login.css'teki `box-shadow: 0 0 0 3px rgba(31,107,171,0.15)` ile birebir aynı odak
  // gölgesi kondu (WCAG 2.4.7 — odağın görünür kalması gerekir).
  const inputCls =
    'w-full h-[44px] rounded-[10px] border-[0.5px] border-[#d2d2d2] bg-[#f8f8f9] ' +
    'px-3 text-[13px] text-[#1b1b1b] placeholder:text-[#6b6b6e] ' +
    'focus:outline-none focus:border-[#1f6bab] focus:shadow-[0_0_0_3px_rgba(31,107,171,0.15)]';

  return (
    <div className="min-h-[100dvh] bg-[#f8f8f9] flex items-center justify-center p-6">
      <form className="w-[288px] flex flex-col" onSubmit={handleSubmit} noValidate>
        {/* Wordmark bileşeni "Gör" hecesini text-brand-700 (#1e40af) ile basıyor; bu ekranda
            buton mavisi #1f6bab. Wordmark.tsx'i DEĞİŞTİRMİYORUZ — aynı bileşen Layout'ta da
            kullanılıyor, orada renk değiştirmek panel geneli bir marka kararı olur ve bu
            turun kapsamında değil. Bunun yerine YALNIZ bu sayfada, Wordmark'ın ürettiği
            .text-brand-700 sınıfını sarmalayıcı üzerinden ezip #1f6bab'a çeviriyoruz. */}
        <div className="flex justify-center mb-[22px] [&_.text-brand-700]:text-[#1f6bab]">
          <Wordmark size="md" />
        </div>

        <h1 className="text-[18px] font-medium text-[#2f2f31] text-center m-0 mb-[22px]">
          Giriş yap
        </h1>

        <label htmlFor="eposta" className="text-[11px] font-medium text-[#6b6b6e] mb-[5px] ml-0.5">
          E-posta
        </label>
        <input
          id="eposta"
          type="email"
          className={`${inputCls} mb-3`}
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="ornek@firma.com.tr"
          autoComplete="username"
          required
        />

        <label htmlFor="sifre" className="text-[11px] font-medium text-[#6b6b6e] mb-[5px] ml-0.5">
          Şifre
        </label>
        <div className="relative mb-3">
          <input
            id="sifre"
            type={showPwd ? 'text' : 'password'}
            className={`${inputCls} pr-10`}
            value={pwd}
            onChange={(e) => setPwd(e.target.value)}
            autoComplete="current-password"
            required
          />
          <button
            type="button"
            onClick={() => setShowPwd((s) => !s)}
            aria-label={showPwd ? 'Şifreyi gizle' : 'Şifreyi göster'}
            className="absolute right-0 top-0 w-10 h-[44px] flex items-center justify-center bg-transparent text-[#6b6b6e] hover:text-[#2f2f31] cursor-pointer"
          >
            {showPwd ? <I.EyeOff size={16} /> : <I.Eye size={16} />}
          </button>
        </div>

        {error && (
          <p role="alert" className="text-[12px] text-[#b42318] text-center mt-1 mb-3">
            {error}
          </p>
        )}

        <button
          type="submit"
          disabled={submitting}
          className="h-[44px] mt-1 rounded-[9999px] bg-[#1f6bab] text-white text-[13px] font-medium disabled:opacity-60 cursor-pointer disabled:cursor-default"
        >
          {submitting ? 'Giriş yapılıyor…' : 'Giriş Yap'}
        </button>

        {/* S115: sağlayıcı künyesi. Logo DEKORATİF (alt=""), çünkü hemen altındaki metin
            aynı bilgiyi zaten veriyor — ekran okuyucuda "NewtonTech NewtonTech" olmasın.
            Ölçüler Yerlice ile BİREBİR: mt-24 / logo 28px / metin 12px, gap 8px.
            ⚠️ Bu dosya `VITE_DEMO_MODE=true` ile 3 halka açık demoya da derleniyor;
            künye orada da doğru bilgi olduğu için dal ayrımı gerekmiyor. */}
        <div className="mt-[24px] flex flex-col items-center gap-[8px]">
          <img src="/newtontech.png" alt="" className="h-[28px] w-auto block" />
          <p className="m-0 text-[12px] text-[#6b7280] text-center">
            RaporGör bir NewtonTech ürünüdür.
          </p>
        </div>
      </form>
    </div>
  );
}
